import dotProps from 'dot-prop-immutable';

import * as actionTypes from './actiontypes';
import states from './states';

const downtime_details = (state = states.downtime_details, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_DOWNTIME_STATE: {
      return dotProps.set(state, action.path, action.payload);
    }

    case actionTypes.DOWNTIME_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          downtime_loading: true,
          downtime_loaded: false,
        }
      };
    }

    case actionTypes.DOWNTIME_LOADED: {
      return {
        ...state,
        downtime_list: action.payload.downTimeList ? action.payload.downTimeList : [...state.downtime_list],
        loaders: {
          ...state.loaders,
          downtime_loading: false,
          downtime_loaded: true,
        }
      };
    }

    case actionTypes.DOWNTIME_LOAD_ERROR: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          downtime_loading: false,
          downtime_loaded: false,
        }
      };
    }

    case actionTypes.DOWNTIME_CREATED: {
      return {
        ...state,
        downtime_list: [action.payload, ...state.downtime_list],
      };
    }

    case actionTypes.DOWNTIME_UPDATED: {
      let index = -1;
      index = state.downtime_list.findIndex(downtime => downtime._id === action.payload._id);
      return {
        ...state,
        downtime_list: index !== -1 ? [...state.downtime_list.slice(0, index), action.payload, ...state.downtime_list.slice(index + 1)] : [...state.downtime_list],
      };
    }

    default:
      return state;
  }
}

export default downtime_details;



// WEBPACK FOOTER //
// ./src/data/redux/downtime_details/reducers.js